export const getRandomDarkColor = () => {
  // Generate random values for RGB, but keep them in a lower range for darkness
  let r = Math.floor(Math.random() * 64); // Values between 0 and 63
  let g = Math.floor(Math.random() * 64); // Values between 0 and 63
  let b = Math.floor(Math.random() * 64); // Values between 0 and 63

  // Return the color in hex format
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const formatTime = (date: Date): string => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Determine AM/PM
  const period = hours >= 12 ? "P.M" : "A.M";

  // Convert to 12-hour format
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes} ${period}`;
};
